import { Inject, Injectable, InjectionToken } from '@angular/core';
import { Logger } from 'src/app/shared/shared-base/amg-ui/logging/logging/logger';

export const LOGGING_ADAPTERS = new InjectionToken<Logger>('Logger');
@Injectable()
export class MultiLogger implements Logger {
  constructor(@Inject(LOGGING_ADAPTERS) private _loggers: Logger[]) {}

  public error(error: Error, message?: string) {
    this._loggers.forEach((l) => {
      l.error(error, message);
    });
  }

  public warning(message: string) {
    this._loggers.forEach((l) => {
      l.warning(message);
    });
  }

  public info(message: string) {
    this._loggers.forEach((l) => {
      l.info(message);
    });
  }
}
